



















































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'propertyLiabilitiesTable'
})
export default class PropertyLiabilitiesTable extends Vue {
  @Prop({ default: () => {} }) public tableDetail: any
  @Prop({ default: '' }) public classNameSelf: string
}
